import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'ui-components/components/button';
import Global from '../../../store/global-selectors';
import { goToOrderDetails } from '../../../store/orders/order-details/orders.details.actions';

import { messages } from '../messages';

const OrderNumber = ({ fulfillmentId }) => {
  const dispatch = useDispatch();
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId }));
  const [salesOrderId] =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId: fulfillment?.fulfillmentPlanId,
        property: 'salesOrdersFulfilledIds',
      }),
    ) || [];

  const orderNumber = useSelector((state) =>
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'orderNumber',
    }),
  );

  const onClick = useCallback(() => {
    dispatch(
      goToOrderDetails({
        salesOrderId,
        fulfillmentPlanId: fulfillment.fulfillmentPlanId,
      }),
    );
  }, [dispatch, salesOrderId, fulfillment.fulfillmentPlanId]);

  if (!orderNumber) {
    return '';
  }
  return (
    <Button onClick={onClick} theme='link'>
      {orderNumber}
    </Button>
  );
};

OrderNumber.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const orderNumber = {
  getMessageDescriptor: () => messages.orderNumber,
  name: <FormattedMessage {...messages.orderNumber} />,
  id: 'orderNumber',
  render: (data) => <OrderNumber fulfillmentId={data.id} />,
};
